import { snowplowInit } from './snowplow';

import Store from '@app/store';
import Actions from '@app/action';

snowplowInit((domainUserId) => {
  Store.dispatch(Actions.Session.setDomainUserId(domainUserId));
});
